<template>
  <layout 
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import Layout from './Layout'

export default {
    components: {
        Layout,
    },
}
</script>